import { render, staticRenderFns } from "./StudentFormFields.vue?vue&type=template&id=200762d9&scoped=true"
import script from "./StudentFormFields.vue?vue&type=script&lang=ts"
export * from "./StudentFormFields.vue?vue&type=script&lang=ts"
import style0 from "./StudentFormFields.vue?vue&type=style&index=0&id=200762d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200762d9",
  null
  
)

export default component.exports